import { render } from "./FacebookIcon.vue?vue&type=template&id=01830682"
const script = {}
script.render = render

export default script